import { createAction } from '@reduxjs/toolkit';

// eslint-disable-next-line import/prefer-default-export
export const deleteContent = createAction('commons/deleteContent', (destination) => ({
  payload: {
    destination,
  },
}));
